<template>
  <p class="font-title font-bold text-neutral-900 tracking-tight text-xl lg:text-2xl lg:leading-8">
    <slot />
  </p>
</template>

<script>
export default {
  name: 'VetsterTitle',
};
</script>
